export const FETCH_MOBILE = 'fetchMobile';
export const FETCH_MENU = 'fetchMenu';